import {
  useFind,
} from 'src/api/APIHooks';
import { defaultQueryConfig } from 'src/components/Backoffice/api/hooks/apiHookOptions';

export const useFindAllPlan = (ids, params = { queryConfig: defaultQueryConfig }) => useFind(
  'plans',
  {
    id: ids,
  },
  {
    queryConfig: {
      placeholderData: undefined,
      enabled: !!ids,
    },
    ...params,
  },
);
